import { Signup } from 'views/auth/signup/account'
// import { SignupPlan } from 'views/auth/signup/plan'
import { APP_NAME } from 'constants'
import { Signin } from 'views/auth/signin'
import { ForgotPassword } from 'views/auth/signin/forgotpassword'
import { ImpersonateSignin } from 'views/auth/signin/impersonate'
import { MagicSignin } from 'views/auth/signin/magic'
import { SigninOTP } from 'views/auth/signin/otp'
import { ResetPassword } from 'views/auth/signin/resetpassword'
import { SocialSignin } from 'views/auth/signin/social'
import { SignupPlan } from 'views/auth/signup/plan'
import { SignupUser } from 'views/auth/signup/user'
import { SignupVerification } from 'views/auth/signup/verify'
// import { SignupPlan as NewPlan } fr  om 'views/auth/signup/new_plan'

const Routes = [
  {
    path: '/signup',
    view: Signup,
    layout: 'auth',
    title: `Sign up to ${APP_NAME}`,
  },
  {
    path: '/signup/verify',
    view: SignupVerification,
    layout: 'auth',
    title: 'Please verify your email address',
  },
  {
    path: '/signup/plan',
    // view: CustomSignupPlan,
    view: SignupPlan,
    layout: 'auth',
    permission: 'owner',
    title: `Sign up to ${APP_NAME}`,
  },
  {
    path: '/signup/user',
    view: SignupUser,
    layout: 'auth',
    title: `Sign up to ${APP_NAME}`,
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: `Welcome to ${APP_NAME}`,
  },
  {
    path: '/signin/otp',
    view: SigninOTP,
    layout: 'auth',
    title: 'Enter verification code',
  },
  {
    path: '/signin/social',
    view: SocialSignin,
    layout: 'auth',
    title: 'Completing Log In',
  },
  {
    path: '/magic',
    view: MagicSignin,
    layout: 'auth',
    title: 'Log In',
  },
  {
    path: '/forgotpassword',
    view: ForgotPassword,
    layout: 'auth',
    title: 'Forgot Your Password?',
  },
  {
    path: '/resetpassword',
    view: ResetPassword,
    layout: 'auth',
    title: 'Reset Your Password',
  },
  {
    path: '/signin/impersonate',
    view: ImpersonateSignin,
    layout: 'auth',
    title: 'Log in via Mission Control',
  },
]

export default Routes
